export default __webpack_public_path__ + "static/media/pending_payment.9b4e2aa5.svg";